<template lang="pug">
div
  app-modal-visualiza-pdf(
    v-if="showModalVisualizaPdf",
    @closeModal="closeModalVisualizaPdf",
    :titulo="tituloModal",
    :tipo="tipoTitulo",
    :conteudo="conteudoModal",
    :isProcesso="true"
  )
  modal-trocar-responsavel(
    v-if="showModalResponsavel",
    :processo="processoTrocado",
    @closeModal="FECHAR_MODAL_TROCAR_RESPONSAVEL",
    @refresh="refresh"
  )
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :showOs="true",
      :showMunicipios="true",
      :configuracaoFiltro="configuracaoFiltro",
      :filtroRapido="filtroRapido",
      :showFiltroTipoMultiplo="showFiltroTipoMultiplo"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro",
    @atualizarFiltro="atualizarFiltro",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="false",
    @exportarCsvFiltroAnalise="exportarCsvFiltroAnalise"
  )
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import AppListagem from '@/components/AppListagem'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import AppModalDesarquivarProcesso from '@/screens/analise/components/modal/AppModalDesarquivarProcesso'
import AppNotificacao from '@/components/mixins/AppNotificacao.vue'
import AppModalVisualizaPdf from '../components/AppModalVisualizaPdf.vue'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import ModalTrocarResponsavel from '@/screens/analise/components/ModalTrocarResponsavel.vue'
const { filtro, showFiltroTipoMultiplo } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    AppModalDesarquivarProcesso,
    AppModalVisualizaPdf,
    ModalTrocarResponsavel
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('TITULOS_PARA_ENTREGA'),
      idProcesso: null,
      processo: {},
      showModalVisualizarProcesso: false,
      items: [],
      protocolo: '',
      tipoProcesso: '',
      conteudoModal: '',
      showModalVisualizaPdf: false,
      totalElements: 0,
      showModalResponsavel: false,
      processoTrocado: null,
      tipoTitulo: '',
      tituloModal: '',
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroSituacao?.TITULOS_PARA_ENTREGA || [],
        filtroResponsavel: filtro?.filtroResponsavel?.TITULOS_PARA_ENTREGA || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'status', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Município', propriedade: 'municipio', sortable: true, ordem: 5, acoes: [], exibir: () => true },
        { id: 5, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 6, acoes: [] },
        { id: 6, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 7, acoes: [] },
        { id: 7, titulo: 'Responsável', propriedade: 'responsavel', ordem: 8, acoes: [] },
        {
          id: 8,
          titulo: 'Ações',
          propriedade: 'tipo',
          ordem: 9,
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso },
            { id: 2, nome: 'Acusar Entrega', icone: 'fa-check', codigo: 'ACUSAR_ENTREGA', ordem: 2, show: this.showAcusarEntregaUsuario },
            { id: 3, nome: 'Trocar Responsável', icone: 'fa-user-edit', codigo: 'TROCAR_RESPONSAVEL', ordem: 3, show: this.showTrocarResponsavel },
            { id: 4, nome: 'Vincular Responsável', icone: 'fa-user-plus', codigo: 'TROCAR_RESPONSAVEL', ordem: 4, show: this.showVincularAnalista }
          ]
        }
      ],
      filtroRapido: null,
      showFiltroTipoMultiplo
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  async created () {
    this.usuario = await this.usuarioLogado
  },

  watch: {
    async '$route' (to, from) {
      this.init()
    }
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    })
  },

  methods: {
    ...mapActions({
      cancelarBoletoDesarquivamento: 'processo/cancelarBoletoDesarquivamento',
      exportarCsvAnalise: 'processo/exportarCsvAnalise'
    }),
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.processo = item
      this.protocolo = item.numeroProtocolo
      this.tipoProcesso = item.tipoCodigo
      this.processo = item
      this.showModalVisualizarProcesso = true
    },
    atualizarFiltro (novoFiltro) {
      this.filtro = {
        ...this.filtro,
        ...novoFiltro
      }
      this.filtroRapido = novoFiltro
    },
    async exportarCsvFiltroAnalise () {
      await this.filtroComColunasExibidas()
      this.exportarCsvAnalise(this.filtro)
    },
    async ACUSAR_ENTREGA  (_this, { item }) {
      if (item.codigoStatus !== 'EM_ENTREGA_TITULO') {
        await _this.executarTramitacao(item.id)
      }
      _this.$router.push({
        name: 'analise/analisar',
        params: {
          idProcesso: item.id,
          acaoCaixa: 'ACUSAR_ENTREGA',
          analiseManual: true
        }
      })
    },
    TROCAR_RESPONSAVEL (_this, { item }) {
      _this.processoTrocado = item
      _this.showModalResponsavel = true
    },
    FECHAR_MODAL_TROCAR_RESPONSAVEL () {
      this.showModalResponsavel = false
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaEntregaTitulo.vue